import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Cookies from "js-cookie";
import Landingheader from "./Landing/Landingheader";
import ScrollToTop from "./ScrollToTop";

const PrivacyPolicy = () => {
  const client_token = Cookies.get('user_token');
  const admin_token = Cookies.get('Admin_token');
  const [is_logged_in,setIs_logged_in] = useState(false);
  
    useEffect(() => {
      if(client_token || admin_token){
        setIs_logged_in(true);
      }else{
      setIs_logged_in(false);
      }
    },[client_token,admin_token])
  
  return (
    <>
    { is_logged_in ? (<><Landingheader /></>) : (<><Header /></>)}
    <div className="min-h-screen bg-slate-50 text-slate-800">
<ScrollToTop />
      {/* Hero Header Section */}
      <div className="px-4 py-16 text-center border-b bg-slate-100 border-slate-200">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#1A3D6D]">
          Privacy Policy
        </h1>
        <p className="max-w-xl mx-auto mt-3 text-sm font-medium text-slate-600 md:text-base">
          Last updated: May 2026. Learn how we collect, protect, and handle your property and account data.
        </p>
      </div>

      {/* Content Container */}
      <div className="max-w-4xl px-6 py-12 mx-auto my-8 bg-white border shadow-sm rounded-xl border-slate-200">
        
        <p className="mb-8 text-sm leading-relaxed text-slate-600">
          At <strong>New World Surveyor</strong>, we value the trust you place in us to handle your personal information and spatial property data. This Privacy Policy describes how we collect, use, process, and disclose your information across our website, booking portals, and dashboard environments.
        </p>

        <div className="space-y-8">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              1. Information We Collect
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-slate-600">
              To provide precise land surveying services, we must collect information that can identify you and the specific properties you request us to evaluate:
            </p>
            <ul className="list-disc pl-5 text-sm text-slate-600 space-y-1.5">
              <li><strong>Account Credentials:</strong> Name, email address, password, phone number, and physical billing address collected upon registration.</li>
              <li><strong>Property Data:</strong> Parcel coordinates, legal descriptions, lot numbers, deeds, and physical addresses needed to conduct Boundary, Subdivision, or Topographic surveys.</li>
              <li><strong>Communication Records:</strong> Messages, files, or technical project requests exchanged through our Admin and Surveyor dashboards.</li>
            </ul>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              2. How We Use Your Information
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-slate-600">
              We process your personal and geographical information for operational purposes necessary to complete our contract with you:
            </p>
            <ul className="list-disc pl-5 text-sm text-slate-600 space-y-1.5">
              <li>To schedule field crew assignments and dispatch physical land surveyors to your property.</li>
              <li>To produce, analyze, and securely upload final CAD maps, legal descriptions, and survey documentation to your client dashboard.</li>
              <li>To manage customer user accounts, handle billing transactions, and respond to incoming operational tickets or support inquiries.</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              3. Data Sharing and Disclosure
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              We do not sell, rent, or trade your personal information or land data to third-party marketing companies. We only share information with licensed professional surveyors, field technical staff, and essential cloud-hosting infrastructures directly involved in executing your land project or running the application portal.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              4. Data Security
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              We implement industry-standard administrative, physical, and electronic security safeguards designed to protect your account data from unauthorized access, loss, or alteration. All surveyor communication channels, database connections, and uploaded file assets are processed through secure network sockets.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              5. Your Rights and Access Controls
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              You maintain full control over your profile data. By logging into your client dashboard, you can review, edit, or update your contact credentials at any time. If you wish to close your account or request the permanent erasure of historical property coordinates and map assets from our platform databases, please file a support request through our Contact Page.
            </p>
          </section>

          {/* Section 6 */}
          <section className="pt-6 border-t border-slate-100">
            <h2 className="text-xl font-bold text-[#1A3D6D] mb-3">
              6. Contact Our Legal Team
            </h2>
            <p className="text-sm leading-relaxed text-slate-600">
              If you have any questions or administrative concerns regarding this Privacy Policy or our overall data security operations, please contact us directly via the message board or email us at: 
              <span className="block mt-2 font-semibold text-slate-700">privacy@newworldsurveyor.com</span>
            </p>
          </section>
        </div>

      </div>
    </div>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;